import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Descriptions } from "../constants/descriptions";
import HelperText from "../../../components/atoms/HelperText";
import {
  Input,
  FormGroup,
  InputHelperText,
  Label,
} from "../../../components/atoms/Form";

const ClinvarAccession = (props) => {
  const { onChange, fetchedClinvarAccession, statusCode } = props;
  const [clinvarAccessionFlag, setclinvarAccessionFlag] = useState(false);
  const [clinvarAccession, setclinvarAccession] = useState(
    fetchedClinvarAccession || ""
  );

  const onChangeClinvarAccession = (e) => {
    setclinvarAccession(e.target.value);
  };

  useEffect(() => {
    if (statusCode && fetchedClinvarAccession) {
      setclinvarAccessionFlag(true);
    }
  }, []);

  useEffect(() => {
    onChange(clinvarAccession, "clinvarAccession");
  }, [clinvarAccession]);

  return (
    <FormGroup className="tw-w-6/12">
      <Label text="Clinvar Accession" />
      <Input
        type="text"
        disabled={clinvarAccessionFlag}
        name="clinvarAccession"
        id="clinvarAccession"
        value={clinvarAccession}
        onChange={(event) => onChangeClinvarAccession(event)}
      />
      <InputHelperText>
        {Descriptions.clinvarAccession.slice(0, 86)}
        <HelperText customText={Descriptions.clinvarAccession} />
      </InputHelperText>
    </FormGroup>
  );
};

ClinvarAccession.propTypes = {
  onChange: PropTypes.func.isRequired,
  fetchedClinvarAccession: PropTypes.string,
  statusCode: PropTypes.number.isRequired,
};

ClinvarAccession.defaultProps = {
  fetchedClinvarAccession: "",
};

export default ClinvarAccession;
